import { render } from "./singleUpload.vue?vue&type=template&id=5fe2aaa6&scoped=true"
import script from "./singleUpload.vue?vue&type=script&lang=js"
export * from "./singleUpload.vue?vue&type=script&lang=js"

import "./singleUpload.vue?vue&type=style&index=0&id=5fe2aaa6&scoped=true&lang=css"

import exportComponent from "/home/webiotcpc/dhruvi/Git/tivo/vue-tivo/tivo-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fe2aaa6"]])

export default __exports__